import styled from "styled-components";

function ArmorFilter() {
    return(Armor)
}

const Armor = [
    ["Equipamento", ""],
    ["Topo","Topo"],
    ["Meio","Meio"],
    ["Baixo","Baixo"],
    ["Acessório","Acessó"],
    ["Escudo","Escudo"],
    ["Sapatos","Calçado"],
    ["Armadura","Armadura"]
]

export default ArmorFilter;